import React, {useEffect} from "react";
import {state} from "../../state";
import {chkDevice, chkObject} from "../utils/Utils";
//
import FormatControlsData from "../data-format/FormatControlsData";
import FormatCustomScriptsData from "../data-format/FormatCustomScriptData";
import FormatCameraData from "../data-format/FormatCameraData";
import FormatFeaturesData from "../data-format/FormatFeaturesData";
import FormatFiltersData from "../data-format/FormatFiltersData";
import FormatLightingData from "../data-format/FormatLightingData";
import FormatMainMenuData from "../data-format/FormatMainMenuData";
import FormatMaterialsData from "../data-format/FormatMaterialsData";
import FormatOrientationData from "../data-format/FormatOrientationData";
import {useSnapshot} from "valtio";
const DataLoader = () => {
  const {dimension,usecase} = useSnapshot(state);
  const formatData = (dataA, dataM, dataL) => {
    
    const appData = dataA;
    const matData = dataM;

    if (state.usecase==="Tall") 
    {
      console.log("Make tall")
      appData.featuresSection.menu[1].menu.reverse();
    }
    
    // titles, names
    state.appTitle = appData['appTitle'];
    
    // paths - models
    state.mainPath = appData['mainPath'];
    state.mainModelLocation = appData['mainPath'] + appData['modelLocation'];
    state.mainModelNames = appData['mainModelNames'];
    state.modelFileFormat = appData['fileFormat'];
    
    // paths - materials
    state.materialsLocation = 'https://' + matData['mainPath'] + matData['materialsLocation'];
    state.materialCategoryLocation = matData['materialCategoryLocation'];

    // ar
    state.arEnabled = appData['arEnabled'];

    // menus
    state.mainMenuEnabled = appData['mainMenuEnabled'];
    
    // parts
    state.defaultMaterials = matData['defaultMaterials'];
    
    // format data
    FormatControlsData(appData.controls);
    FormatMainMenuData(appData.mainMenu, appData.configMenu);
    FormatFiltersData(appData['filterMenus']);
    FormatMaterialsData(appData.materialsSection.menu, matData["mainMaterialSets"], matData["developerControls"]);
    FormatLightingData(dataL);
    
    // if data exits
    chkObject(appData.featuresSection) && FormatFeaturesData(appData.featuresSection.menu);
    chkObject(appData['orientationSection']) && FormatOrientationData(appData['orientationSection']);

    // add custom scripts if present
    chkObject(appData.customScripts) && FormatCustomScriptsData(appData.customScripts);

    // add camera data if present
    chkObject(appData.camera) && FormatCameraData(appData.camera);
    
    // set ready
    state.userDevice = chkDevice();
    state.appReady = true;
    
  }
  
  useEffect(() => {
    
    // set appropriate urls for data
    // ('https://modeconfigurator.com/assets/Mode2/app-data/app-data.json')
    
    // from local public
    // ------------------------------------------------------------------------------------------------
    
    // const dataUrls = ['./json/standard-minimal/app-data.json', './json/standard-minimal/material-data.json']; // standard-min
    
    // const dataUrls = ['./json/standard-minimal-orientation/app-data.json', './json/standard-minimal-orientation/material-data.json']; // standard-min + orientation
    
    // const dataUrls = ['./json/standard/app-data.json', './json/standard/material-data.json']; // standard
    
    // const dataUrls = ['./json/module/app-data.json', './json/module/material-data.json']; // modular
    
    const dataUrls = ['./json/app-data.json', './json/material-data.json', './json/light-data.json'];
    
    // ------------------------------------
    // remote data test - getting data from remote
    // const dataUrls = ['./json/standard-remote/app-data.json', './json/standard-remote/material-data.json'];
    
    // ---------------------------------------------------------------------------------------------
    
    dimension && Promise.all(dataUrls.map(url => fetch(url)
      .then(r => r.json()))).then(([data1, data2, data3]) => {
      data1.mainModelNames=[`PTH-${dimension[0]}.${dimension[1]}`]
      formatData(data1, data2, data3);

    }).catch(error => console.log('error - getting data', error))
    
  },[usecase,dimension]);
  
};

export default DataLoader;
